import React from 'react'
// import RenderSteps from './RenderSteps.jsx'

const AddCourse = () => {
  return (
    // <div className=' mx-auto w-11/12 max-w-[1000px] py-10'>
    <div className=' lg:w-[40%] '>
       
        <div className=' lg:w-[100%] hidden max-w-[400px] flex-1 rounded-md border-[1px] border-richblack-700 bg-gray-200 p-6 lg:block'>
            <p className='mb-8 text-lg text-richblack-5'>⚡WeDesigneTees Guidelines</p>
            <ul className='ml-5 list-item list-disc space-y-4 text-xs text-richblack-5'>
                <li>Do not upload more then 5 images .</li>
                <li>Product Photos must be professional otherwise will be deleted by the team.</li>
                <li>Images should be in portrait format</li>
                <li>Your chat is under supervisiory.</li>
                <li>Dont share personal details with customer.</li>
                <li>Any problem just contact the admin.</li>
                <li>Deal with customer soflty otherwise your account will be banned by the team </li>
                <li>Dont try to down the respect of the platform.</li>
            </ul>
        </div>
    </div>
// </div>
  )
}

export default AddCourse